import React, {useEffect} from 'react'
import {Image, Rect, Transformer} from "react-konva";
import useImage from "use-image";
import {parseInt} from "lodash";
import {BLOCK_SNAP_SIZE} from "../../../constants/design.constant";

const BackgroundRectangleShape = ({
                                      backgroundRef,
                                      background,
                                      stageHeight,
                                      stageWidth,
                                  }) => {

    return (
        <>
            {(background?.colorType === 'linear' || background?.colorType === 'radial') &&
                <Rect
                    ref={backgroundRef}
                    x={0}
                    y={0}
                    width={stageWidth}
                    height={stageHeight}
                    {...background?.props}
                    listening={false}/>
            }

            {background?.colorType === 'solid' &&
                <Rect
                    ref={backgroundRef}
                    fill={background?.backgroundColor || ''}
                    x={0}
                    y={0}
                    width={stageWidth}
                    height={stageHeight}
                    listening={false}/>
            }
        </>
    )
}

export default BackgroundRectangleShape
